__turbopack_context__.v({
  "container": "ProspectSearchCard-module__k8NpBG__container",
  "cta": "ProspectSearchCard-module__k8NpBG__cta",
  "desc": "ProspectSearchCard-module__k8NpBG__desc",
  "header": "ProspectSearchCard-module__k8NpBG__header",
  "icon": "ProspectSearchCard-module__k8NpBG__icon",
  "title": "ProspectSearchCard-module__k8NpBG__title",
});
